import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-shared-react/pkg/redux/flags/hooks';
import VisuallyHidden from '@wix/da-shared-react/pkg/a11y/VisuallyHidden';
import PageContainer from '../PageContainer';
import FacetPage from '../FacetPage';
import FeedLayout from '../FeedLayout';
import ContentLoader from '../ContentLoader';
import BrowseThumbLayout from '../BrowseThumbLayout';
import s from './PostsPage.scss';

export interface Props {}

const PostsPage: React.FC<Props> = () => {
  const { t } = useTranslation();
  const shouldRenderH1 = useFlag('proposed_h1s');
  return (
    <PageContainer>
      {shouldRenderH1 && (
        <VisuallyHidden>
          <h1>{t('postsPage.heading')}</h1>
        </VisuallyHidden>
      )}
      <div className={s['root']}>
        <FacetPage withMargin={false}>
          <FeedLayout>
            <ContentLoader>
              <BrowseThumbLayout duperbrowseTitle={t('common.posts')} />
            </ContentLoader>
          </FeedLayout>
        </FacetPage>
      </div>
    </PageContainer>
  );
};
PostsPage.displayName = 'PostsPage';

export default PostsPage;
